import { Fragment, type ReactNode } from "react";

interface TenantRevisionBoundaryProps {
  revision: number;
  children: ReactNode;
}

export const TenantRevisionBoundary = ({
  revision,
  children,
}: TenantRevisionBoundaryProps) => (
  <Fragment key={revision}>{children}</Fragment>
);
